var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateBannerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 330,
    viewBox: "0 0 1920 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 330,
    fill: "url(#paint0_linear_9390_28624)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 330,
    fill: "url(#paint1_radial_9390_28624)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9390_28624",
    x1: 583.178,
    y1: -53.1116,
    x2: 2307.15,
    y2: 808.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C2538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1F2B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561887,
    stopColor: "#2B3B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1F2B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2538"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9390_28624",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-232.952 -134.174) rotate(21.2155) scale(1585.28 5270.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735017,
    stopColor: "#151C2B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBannerBg);
export default __webpack_public_path__ + "static/media/certificate-banner-bg.0dc89a9a92318da9df9d11881bb8508b.svg";
export { ForwardRef as ReactComponent };